<app-page-layout [title]="'PASSWORD_RESET.RESET_PASSWORD'" [displayCustomerService]="false">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 col-md-offset-3">
        <mat-card>
          <mat-card-header>
            <mat-card-title class="center">{{'PASSWORD_RESET.RESET_PASSWORD' | translate}}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="row">
              @if (isLoading()) {
                <app-loading></app-loading>
              } @else {
                @if (hasBeenReset) {
                  <ng-container *ngTemplateOutlet="successMessage"></ng-container>
                } @else {
                  <ng-container *ngTemplateOutlet="errorMessage"></ng-container>
                  <form [formGroup]="form">
                    <mat-form-field class="col-md-12">
                      <mat-label>{{'COMMON.USER_NAME_PLACEHOLDER' | translate}}</mat-label>
                      <input matInput name="email" type="text" formControlName="loginID"
                        class="full-width">
                      <mat-error>
                        {{'VALIDATION.REQUIRED'|translate}}
                      </mat-error>
                    </mat-form-field>
                    <div class="col-md-12">
                      <button mat-raised-button color="primary" type="submit" class="full-width"
                        [disabled]="isLoading()" (click)="submit()">
                        {{'COMMON.CONFIRM' | translate}}
                      </button>
                    </div>
                    <div class="col-md-12 top15">
                      <button mat-button color="primary" type="button" class="full-width"
                        [routerLink]="['/login']">
                        {{'COMMON.BACK' | translate}}
                      </button>
                    </div>
                  </form>
                }
              }
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</app-page-layout>
<ng-template #errorMessage>
  @if (errorMatcher.isError()) {
    <div class="col-md-12">
      <div class="alert custom-danger text-left" role="alert">
        <p class="error">
          <mat-icon class="danger">error</mat-icon>
          @if (!errorMatcher.isMissingVerification()) {
            @for (error of errorMatcher.logError; track error) {
              <span>{{error.message | translate}}</span>
            }
          } @else {
            @for (error of errorMatcher.logError; track error) {
              <a (click)="verifyAccount()">{{error.message |
              translate:{arg:error.arg} }}</a>
            }
          }
        </p>
      </div>
    </div>
  }
</ng-template>
<ng-template #successMessage>
  <div class="col-md-12">
    <div class="alert alert-success" role="alert">
      <p>{{ 'PASSWORD_RESET.SUCCESS_TEXT' |translate }}</p>
      <span>{{'PASSWORD_RESET.SUCCESS_TITLE' |translate }}</span>
      <p> {{'COMMON.GO_TO_LOGIN' | translate }}</p>
    </div>
  </div>
</ng-template>